<template>
	<div>
		<!-- <CustomSituations/> -->
	</div>
</template>

<script>
import * as BABYLON from 'babylonjs';
import Constructor from './components/Constructor';
import {mapGetters, mapState,mapMutations} from 'vuex'
import MediaManager from "@/api/MediaManager";
import MaterialManager from "@/components/babylonjs/Materials";
import {Media} from '@/store/flux360/MediaManagerDataTypes';
import {Request} from '@/store/flux360/Request';
import {NotifyPositionEvent} from '@/store/flux360/EventDataTypes';
// import CustomSituations from "@/components/flux360/CustomSituations/CustomSituations";

export default {
	// components: {CustomSituations},
	props: {
		debug: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	data(){
		this.publicPath = process.env.BASE_URL,

		// BABYLON Data
		this.gyrosCamera = null,
		this.mainCamera = null,
		this.situationsNode = undefined, // All situations are gathered below this node
		this.usersNode = undefined, // All users are gathered below this node
		this.eventsNode = undefined, // All events are gathered below this node
		this.components = [],
		this.assetsManager = null

		// User-Update Data
		this.localUserPosition = new BABYLON.Vector3.Zero(),
		this.localUserRotation = new BABYLON.Vector4.Zero(),
		this.lastUserUpdateTimeStamp = 0.0,
		this.userUpdateDeltaMS = 1000 / 10, // Defines the milliseconds between user updates

		this.tapedTwice = false,
		this.vrHelper = undefined
        return {}
    },
	computed: {
		...mapState(['vrMode']),
		...mapGetters([
			'situations','currentPrefabs', 'currentSituation', 'currentSituationID', 'panoramaTour', 'prefabsForSituation', 'remoteUsersInCurrentSituation','doRendering','secondaryColor','primaryColor','roomRotations', 'followModeratorMode',
			'localUser', 'events','commands','isVRMode', 'users',"isGyrosActive","enableCommunication","enableZooming","enablePanoramaVideoAutoplay",'fontFamily','thumbnailType','cameraZoom','enablePreloadAllSituations'
		]),
		...mapState({isOnboardingComplete: (state) => state.session.isOnboardingComplete}),
		currentEvents(){
			return this.events.filter( x => x.getSituationID() === this.currentSituationID );
		},
		currentSituationRuntimeStateRequests(){
			return this.currentSituation ? this.currentSituation.runtimeState.requests: undefined;
		}
	},
	mounted(){ // Initialize
	 	setTimeout(() => { // TODO: Remove unsafe (window.scene undefined when initialize called)
			this.initialize();
			this.startRenderLoop();
		}, 0);
	},
	methods: {
		...mapMutations(["updateUser",'updateRuntimeState','setLoadingscreenVisible']),
		initialize(){
			this.initializeScene();
			this.initializeAssetsManager();
			this.initializeCamera();
			this.initializeLighting();
			this.initializeSceneGraph();
			this.initializeActionManager();
			MaterialManager.initialize(window.scene);
		},
		getCurrentComponents(){
			return this.components.filter(x => x.getSituationID() === this.currentSituationID);
		},
		initializeScene() {
			window.scene = new BABYLON.Scene(window.engine);
			window.scene.useRightHandedSystem = false;
			window.scene.clearColor = BABYLON.Color3.White();
			if(this.debug)
				window.scene.debugLayer.show();
			window.scene.onBeforeCameraRenderObservable.add((camera) => {
                let timeStampInMs = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
                if(timeStampInMs - this.lastUserUpdateTimeStamp > this.userUpdateDeltaMS || this.lastUserUpdateTimeStamp === 0){
				    let position = camera.position;
				    let rotation = camera.absoluteRotation.toEulerAngles();
				    let update = {
    					id: this.$store.state.flux360.localUserID,
					    currentSituationID: this.$store.getters.currentSituationID
				    };
				    if(!position.equalsWithEpsilon(this.localUserPosition, 0.001 )){
    					this.localUserPosition = { ...position };
					    update.position = { ...position };
                        update.position.x = Math.round(update.position.x * 100)/100;//update.position.x.toFixed(3);
                        update.position.y = Math.round(update.position.y * 100)/100;//update.position.x.toFixed(3);
                        update.position.z = Math.round(update.position.z * 100)/100;//update.position.x.toFixed(3);
				    }
				    if(!rotation.equalsWithEpsilon( this.localUserRotation, 0.001 )){
    					this.localUserRotation = { ...rotation };
					    update.rotation = { ...rotation };
                        update.rotation.x = Math.round(update.rotation.x * 100)/100;//update.position.x.toFixed(3);
                        update.rotation.y = Math.round(update.rotation.y * 100)/100;//update.position.x.toFixed(3);
                        update.rotation.z = Math.round(update.rotation.z * 100)/100;//update.position.x.toFixed(3);
				    }
				    if(Object.keys(update).length > 2){
					    this.$store.commit('updateUser', update);
                        this.lastUserUpdateTimeStamp = timeStampInMs;
					}
                }
			})

			document.getElementById("renderCanvas").addEventListener("dblclick", () => {
				this.onDblClick();
			});

			document.getElementById("renderCanvas").addEventListener("wheel", (e) => {
				this.onZoom(e);
			});

			document.getElementById("renderCanvas").addEventListener('gestureend', (e) => {
				this.onZoom(e);
			});
			
			//dblclick for mobile
			document.getElementById("renderCanvas").addEventListener("touchstart", (e) => {
				if(!this.tapedTwice) {
					this.tapedTwice = true;
					setTimeout( function() { this.tapedTwice = false; }, 300 );
				}else{
					this.onDblClick();
				}		
			});
		},
		initializeAssetsManager () {
			this.assetsManager = new BABYLON.AssetsManager(window.scene);
			this.assetsManager.onTaskErrorObservable.add(function (task) {
				console.log('Flux360BabylonEngine:: Task failed', task.errorObject.message, task.errorObject.exception);
			});
			this.assetsManager.onProgress = (remainingCount, totalCount) => {
				window.engine.loadingScreen.setLoadingUIText((100 * (totalCount - remainingCount) / totalCount).toFixed(0) + "%");
				//console.log( 'We are loading the scene. ' + remainingCount + ' out of ' + totalCount + ' items still need to be loaded.' );
			};
		},
		initializeCamera () {
			this.mainCamera = new BABYLON.ArcRotateCamera("MainCamera",Math.PI / 2,Math.PI / 2,2,BABYLON.Vector3.Zero(),window.scene); 
			this.mainCamera.attachControl(document.getElementById("renderCanvas"), true, false,4);
			this.mainCamera.inputs.attached.mousewheel.detachControl(document.getElementById("renderCanvas"));
			// this.mainCamera.invertRotation = true;
			this.mainCamera.lowerRadiusLimit = 1; // Stop zooming in
			this.mainCamera.upperRadiusLimit = 1; // Stop zooming out
			this.mainCamera.angularSensibilityX = 3000;
			this.mainCamera.angularSensibilityY = 3000;
			this.mainCamera.fov = this.cameraZoom;
			this.mainCamera.minZ = 0.1;
			this.mainCamera.inputs.attached.keyboard.keysDown = [38];
			this.mainCamera.inputs.attached.keyboard.keysUp = [40];
			this.mainCamera.inputs.attached.keyboard.keysLeft = [39];
			this.mainCamera.inputs.attached.keyboard.keysRight = [37];

			this.gyrosCamera = new BABYLON.DeviceOrientationCamera("GyrosCamera",BABYLON.Vector3.Zero(),window.scene); 
			this.gyrosCamera.attachControl(document.getElementById("renderCanvas"), true);
		},
		initializeLighting () {
			new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(1, 1, 0), window.scene);
		},
		initializeSceneGraph () {
			// Check if we already have a situations node
			if (!this.situationsNode)
				this.situationsNode = new BABYLON.TransformNode("Situations", window.scene);
			if (!this.usersNode)
				this.usersNode = new BABYLON.TransformNode("Users", window.scene);
			if (!this.eventsNode)
				this.eventsNode = new BABYLON.TransformNode("Events", window.scene);
			Promise.resolve(this.$store.dispatch('broadcastUserUpdate', this.user));
		},
		initializeActionManager() {
			window.scene.actionManager = new BABYLON.ActionManager(window.scene);

			/// Register the function to call all users to the current user.
			window.scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction({trigger: BABYLON.ActionManager.OnKeyDownTrigger, parameter: 'c' },() => { 
				if(this.localUser.getRole() === "moderator"){
					let camera = window.scene.activeCamera;
					this.$store.dispatch("sendCommand",{type: "CommandSendModeratorPosition", data: {type: "Default", alpha: camera.alpha, beta: camera.beta, fov: camera.fov}});
				}
			}));

			// // From 2D view to fullscreen VR
			// window.scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction({
			// 		trigger: BABYLON.ActionManager.OnKeyDownTrigger,
			// 		parameter: 'v' //press "s" key
			// 	},
			// 	function () { vrHelper.enterVR(); }
			// ));
			// // From fullscreenVR to 2D view
			// window.scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction({
			// 		trigger: BABYLON.ActionManager.OnKeyDownTrigger,
			// 		parameter: 'e' //press "e" key
			// 	},
			// 	function () { vrHelper.exitVR(); document.exitFullscreen();}
			// ));

			// Add Testuser
			// window.scene.actionManager.registerAction(new BABYLON.ExecuteCodeAction({
			// 		trigger: BABYLON.ActionManager.OnKeyDownTrigger,
			// 		parameter: 'u' //press "s" key
			// 	},
			// 	() => { 
			// 		this.$store.dispatch('addTestUser');
			// 	}
			// ));
		},
		render () {
			if(window.scene && this.doRendering){
				// Call the update function on all components...
				this.components.filter(x => x.getSituationID() === this.currentSituationID).forEach(x => {
					x.update(this)
				});
				MaterialManager.update();
				window.scene.render();
			}
		},
		startRenderLoop () {
			window.engine.runRenderLoop(() => this.render());
		},

		enterSituation (newSituation){
			if(!newSituation)
				return;
			
			// Camera Rotation & Animation when entering new room
			let alpha = 0;
			let beta = 0;
			this.roomRotations.forEach(roomRotation => {
				if(roomRotation.name == newSituation.name.trim()){
					// alpha
					if(roomRotation.alpha != undefined)
						alpha = roomRotation.isRad ? roomRotation.alpha : roomRotation.alpha * Math.PI / 180;
					else
						alpha = 0;

					// beta
					if(roomRotation.beta != undefined)
						beta = roomRotation.isRad ? roomRotation.beta : roomRotation.beta * Math.PI / 180;
					else
						beta = Math.PI/2;

					// zoom
					if(roomRotation.zoom != undefined)
						window.scene.activeCamera.fov = roomRotation.zoom;
					else
						window.scene.activeCamera.fov = this.cameraZoom;
				}
			});  

			let camera = window.scene.activeCamera;
			camera.target = new BABYLON.Vector3(0,0,0).subtract(camera.target.scale(1.5));

			camera.alpha -= Math.PI;
			camera.alpha %= 2*Math.PI;
			camera.alpha += 0 >= camera.alpha ? 2*Math.PI : 0;

			alpha %= 2*Math.PI;
			alpha += 0 >= alpha ? 2*Math.PI : 0;
			if(Math.abs(camera.alpha) - Math.abs(alpha)> Math.PI)
				alpha +=  Math.PI*2;
			else if(Math.abs(alpha) - Math.abs(camera.alpha)> Math.PI)
				alpha -=  Math.PI*2;

			if(camera.target.x == 0 && camera.target.y == 0 && camera.target.z == 0){
				camera.alpha = alpha;
				camera.beta = beta;
			}else{
				let fps = 60;
				let duration = 1000;

				var ease1 = new BABYLON.CubicEase();
				ease1.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEOUT);
				BABYLON.Animation.CreateAndStartAnimation("", camera, "target", fps, (duration/1000)*fps, camera.target, new BABYLON.Vector3(0,0,0), 0, ease1);
				setTimeout(() => {
					var ease2 = new BABYLON.CubicEase();
					ease2.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
					BABYLON.Animation.CreateAndStartAnimation("", camera, "alpha", fps, (duration/1000)*fps, camera.alpha, alpha, 0, ease2);
					BABYLON.Animation.CreateAndStartAnimation("", camera, "beta", fps, (duration/1000)*fps, camera.beta, beta, 0, ease2);
				}, 400);
			}
			
			// Create/Activate Nodes
			console.log(`... going to enter ${JSON.stringify(newSituation.name)}`);
			if (!this.coversSituation(newSituation)) {
				this.preloadSituation(newSituation).then(() => {
					console.log("Now, creating Situation");
					this.createSituation(newSituation);
				});
			} else {
				console.log("... reactivating Situation");
				const situationNode = this.situationsNode;
				if (situationNode) {
					situationNode.getChildren().forEach(child => {
						if (child.name === this.getSituationNodeName(newSituation.getID())) {
							console.log("... enabling situation..." + child.name + " " + child.id + child.getChildren().length);
							child.setEnabled(true);
						}
					})
				}
				const componentsToCheck = this.components.filter(x => x.getSituationID() === newSituation.getSituationID());
				componentsToCheck.forEach(component => {component.enable()});
			}
		},
		leaveSituation (oldSituation) {
			if (!oldSituation)
				return;

			console.log(`... leaving situation ${oldSituation ? JSON.stringify(oldSituation.name) : "none"}`);
			const situationNode = this.situationsNode;
			if (situationNode) {
				situationNode.getChildren().forEach(child => {
					if (child.name === this.getSituationNodeName(oldSituation.getID())) {
						console.log("... disabling situation...");
						child.setEnabled(false);
					}
				})
			}

			let componentsToCheck = this.components.filter(x => x.getSituationID() === oldSituation.getSituationID());
			componentsToCheck.forEach(component => {
				component.disable();
			})
		},
		preloadAllMedia() {
			console.log("Preloading all Textures/Panoramas");
			const assetM = this.assetsManager;
			return new Promise(function (resolve, reject) {
				MediaManager.media.forEach((texture) => {
					if(texture.getType() === Media.MediaType.Texture && !texture.getTexture()){
						const task = assetM.addTextureTask(texture.id,texture.getURL(),false,false);
						task.onSuccess = (task) => {
							texture.setTexture(task.texture);
							if(!texture.getWidth() || !texture.getHeight())
								texture.setSize(task.texture.getSize().width / 20,task.texture.getSize().height / 20);
						};
					}
				});
				assetM.onFinish = () => {
					console.log("... assets loaded.");
					resolve();
				};
				assetM.onTaskError = (error) => {
					console.error("... Loading assets failed!");
					reject(error);
				};
				console.log("... start preloading!");
				assetM.load();
			});
		},
		preloadSituation (situation) {
			console.log("... preloading situation " + situation.getName());
			let contentIDs = situation.getContentIDs();

			this.prefabsForSituation(situation.getID()).map(x => {
				if (x.getContentIDs()) {
					contentIDs = contentIDs.concat(x.getContentIDs());
				}
			})

			const assetM = this.assetsManager;
			return new Promise(
				function (resolve, reject) {
					MediaManager.media.forEach(texture => {
						if (texture.getType() === Media.MediaType.Texture && !texture.getTexture() && contentIDs.includes(texture.id)) {
							const task = assetM.addTextureTask(texture.id, texture.getURL(),false,false);
							task.onSuccess = task => {
								texture.setTexture(task.texture);
								if (!texture.getWidth() || !texture.getHeight())
									texture.setSize(task.texture.getSize().width / 20,task.texture.getSize().height / 20);
							};
						}
					})
					assetM.onFinish = () => {
						console.log("... assets loaded.");
						resolve();
					}
					assetM.onTaskError = (error) => {
						console.error("... Loading assets failed!");
						reject(error);
					}
					console.log("... start preloading!")
					assetM.load();
				}
			);
		},
		createSituation (situation) {
			let situationNode = window.scene.getNodeByName(this.getSituationNodeName(situation.getID()));
			if(situationNode)
				return;

			situationNode = new BABYLON.TransformNode(this.getSituationNodeName(situation.getID()), window.scene);
			var situationsNode = this.situationsNode;
			situationNode.parent = situationsNode;
			
			// Construct Panorama
			let prefabComponent = Constructor.constructPrefabSubgraph(this, situation);
			this.components.push(prefabComponent);
			prefabComponent.getRootNode().parent = situationNode;

			// Construct all contents
			this.prefabsForSituation(situation.getID()).map(x => {
				//console.log("constructPrefabSubgraph: type: " + x.getType());
				let prefabComponent = Constructor.constructPrefabSubgraph(this, x);
				this.components.push(prefabComponent);
				prefabComponent.getRootNode().parent = situationNode;
			})
		},
		coversSituation (situation) {
			//console.log("Test if we have this situation " + situation.getName() );
			if (window.scene.getNodeByName(this.getSituationNodeName(situation.getID())))
				return true;
			else
				return false;
		},
		getSituationNodeName (situation) {
			let name = situation;
			if (!Number.isInteger(situation))
				name = situation.getID();
			return "Situation_" + name;
		},
		onDblClick() {
			if(this.enableCommunication){
				// We try to pick an object
				var pickResult = window.scene.pick(window.scene.pointerX, window.scene.pointerY);
				if( pickResult.hit ) {

					let pos = pickResult.pickedPoint;
					pos.x = Math.round(pos.x * 100)/100;
					pos.y = Math.round(pos.y * 100)/100;
					pos.z = Math.round(pos.z * 100)/100;

					let event = new NotifyPositionEvent( { 
						userID: this.$store.state.flux360.localUserID,
						situationID: this.$store.getters.currentSituationID,
						position: pos,
						duration: 3000,
						rotation: window.scene.rotation,
						color: this.localUser.getColor()
					});
					this.$store.commit( 'postEvent', event );
				}
				// let audio = new Audio(require('@/assets/sounds/ripple.mp3'));
				// audio.type = "audio/mpeg";
				// audio.play();
			}
			if(this.isOnboardingComplete){
				// let audio = new Audio(require('@/assets/sounds/ripple.mp3'));
				// audio.type = "audio/mpeg";
				// audio.play();
			}
		},
		onZoom(e) {
			if(this.enableZooming){
				let scale = e.deltaY ? e.deltaY: e.scale;
				let fov = this.mainCamera.fov;
				if(fov < 1.350 && 0 < scale )
					this.mainCamera.fov += scale * 0.0005;
				if(0.7 < fov && scale < 0)
					this.mainCamera.fov += scale * 0.0005;	
			}
		}
	},
	watch:{
		followModeratorMode(){
            if(this.followModeratorMode){
                window.scene.activeCamera.detachControl();
            }else{
                window.scene.activeCamera.attachControl(document.getElementById("renderCanvas"), true, true, 4);
                window.scene.activeCamera.inputs.attached.mousewheel.detachControl(document.getElementById("renderCanvas"));
            }  
        },
		situations(){
			if(this.enablePreloadAllSituations) this.preloadAllMedia();
		},
		currentSituationRuntimeStateRequests(){	
			this.getCurrentComponents().forEach(x => {	
				if(x.getType() == "VideoSphere"){
					this.currentSituationRuntimeStateRequests.forEach(r => {
						if (r.requestType === Request.RequestType.Pause) 
							x.pause();
						
						if (r.requestType === Request.RequestType.Play) 
							x.play();
						
						if (r.requestType === Request.RequestType.Reset) 
							x.reset();
						
						if (r.requestType === Request.RequestType.JumpToTimePosition) 
							x.jumpToTimePosition(r.timeToJumpTo);
						
						if (r.requestType === Request.RequestType.ChangeVolume) 
							x.changeVolume(r.volume);
					})
				}
				this.currentSituationRuntimeStateRequests.length = 0;
			});
		},
		currentSituation: function (newValue, oldValue) {
			// Check if the value actually changed...
			if (oldValue && newValue && newValue.getID() === oldValue.getID())
				return;
			console.log(`Entered a new situation ${JSON.stringify(newValue.name)} <= ${oldValue ? JSON.stringify(oldValue.name) : "none"}`);
			if (oldValue === undefined || newValue.id !== oldValue.id) {
				if (oldValue !== -1) // only leave existing situations
					this.leaveSituation(oldValue);
				this.enterSituation(newValue);
			}
		},
		localUser: function (newValue, oldValue) {
			if (oldValue && newValue && oldValue.getID() === newValue.getID())
				return;
			console.log("Local user changed to " + newValue.getID());
		},
		remoteUsersInCurrentSituation: function (newValue, oldValue) {
			console.info(`PanoramaScene::remoteUsersInCurrentSituation old: ${JSON.stringify(oldValue)} new: ${JSON.stringify(newValue)}`);
			// Modify the scenegraph accordingly...
			let usersNode = window.scene.getNodeByName("Users");
			// Loop over users in current situation
			if (usersNode) {
				// Add all users missing in the current situation
				let userIDs = newValue.map(x => x.getID());
				usersNode.getDescendants(true, n => !userIDs.includes(n.name)).forEach(x => {
					x.setEnabled(false)
					// Search for matching component...
					let component = this.components.filter( y => y.getID() === x.name );
					console.log("Found " + component.length + " components to be removed");
					if(component) {
						component.forEach( x => {
							console.log("Removing " + x.getID() );
							x.destruct();
							this.components.splice( this.components.indexOf( x ), 1 );
						});
					}				 			
				}); 
				usersNode.getDescendants(true, n => userIDs.includes(n.name)).forEach(x => {
					x.setEnabled(true);
					// Remove the user from the list
					userIDs = userIDs.filter(y => y !== x.name);
				});
				const usersToAdd = newValue.filter(x => userIDs.includes(x.getID()));
				if(usersToAdd){
					usersToAdd.forEach(newUser => {
						let userComponent = Constructor.constructPrefabSubgraph(this, newUser);
						this.components.push(userComponent);
						userComponent.getRootNode().parent = usersNode;
					})
				}
			} 
		},  
		currentEvents: function (newValue, oldValue) {
			//console.info(`PanoramaScene::EventsChanged old: ${JSON.stringify(oldValue)} new: ${JSON.stringify(newValue)}`);
			// Now create the corresponding components...
			if(!window.scene)
				return;

			// Modify the scenegraph accordingly...
			let eventsNode = window.scene.getNodeByName("Events");
			// Loop over users in current situation
			if (eventsNode) {
				// Add all users missing in the current situation
				let eventIDs = newValue.map(x => x.getID());

				eventsNode.getDescendants(true, n => !eventIDs.includes(n.name)).forEach(x => {
					x.setEnabled(false);
					// Search for matching component...
					let component = this.components.filter( y => y.getID() === x.name );
					console.log("Found " + component.length + " components to be removed");
					if( component ) {
						component.forEach( x => {
							console.log("Removing " + x.getID() );
							x.destruct();
							this.components.splice( this.components.indexOf( x ), 1 );
						});
					}
				});

				eventsNode.getDescendants(true, n => eventIDs.includes(n.name)).forEach(x => {
					x.setEnabled(true);
					// Remove the user from the list
					eventIDs = eventIDs.filter(y => y !== x.name);
				});

				const eventsToAdd = newValue.filter(x => eventIDs.includes(x.getID()));
				if(eventsToAdd){
					eventsToAdd.forEach(newEvent => {
						//console.log("Adding event " + JSON.stringify(newEvent));
						let eventComponent = Constructor.constructPrefabSubgraph(this, newEvent);
						this.components.push(eventComponent);
						eventComponent.getRootNode().parent = eventsNode;
					})
				}
			}
		},
		isVRMode: function(newValue, oldValue){
			console.log("isVRMode changed");
			if(newValue){ 
				if(!this.vrHelper)
					this.vrHelper = window.scene.createDefaultVRExperience();
				this.vrHelper.enterVR(); 
			}else{ 
				this.vrHelper.exitVR(); 
				document.exitFullscreen();
			}
		},
		debug: function(val){
			if(window.scene && val)
				window.scene.debugLayer.show();
			else
				window.scene.debugLayer.hide();
		},
		cameraZoom(){
			window.scene.activeCamera.fov = this.cameraZoom;
		},
		isGyrosActive(){
			if(this.isGyrosActive){
				if (typeof DeviceOrientationEvent.requestPermission === 'function') 
					DeviceOrientationEvent.requestPermission().then(permissionState => {
						if (permissionState === 'granted') 
							window.addEventListener('deviceorientation', () => {});
						
					}).catch(console.error);
				window.scene.activeCamera = this.gyrosCamera;
			}else{
				window.scene.activeCamera = this.mainCamera;
			}
		},
	},
}
</script>
